"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactPopper = require("react-popper");
var _classnames = _interopRequireDefault(require("classnames"));
var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));
var _noop = _interopRequireDefault(require("lodash/fp/noop"));
var _logDeprecatedWarnings = _interopRequireDefault(require("../../utils/logDeprecatedWarnings"));
var _portalRoot = require("../../utils/portalRoot");
var _useClickOutside = _interopRequireDefault(require("../../hooks/useClickOutside"));
var _getMenuItems = _interopRequireDefault(require("../menuItems/getMenuItems"));
var _MenuItems = _interopRequireDefault(require("../menuItems/MenuItems"));
var _menuItemsPropTypes = _interopRequireDefault(require("./menuItemsPropTypes"));
var _DropdownToggleButton = _interopRequireDefault(require("./DropdownToggleButton"));
var _SplitCaretButton = _interopRequireDefault(require("./SplitCaretButton"));
var _Caret = _interopRequireDefault(require("./Caret"));
var _excluded = ["id", "items", "bsSize", "bsStyle", "disabled", "iconOnly", "title", "splitButton", "customDropdown", "toggleClassName", "dropdownClassName", "className", "open", "dropup", "pullRight", "noCaret", "onOpen", "onClose", "onLabelButtonClick", "usePortal", "popperConfig"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var getPlacement = function getPlacement(pullRight, dropup) {
  if (pullRight && dropup) {
    return 'top-end';
  }
  if (!pullRight && dropup) {
    return 'top-start';
  }
  if (pullRight && !dropup) {
    return 'bottom-end';
  }
  return 'bottom-start';
};
var ButtonDropdown = function ButtonDropdown(props) {
  var id = props.id,
    items = props.items,
    bsSize = props.bsSize,
    bsStyle = props.bsStyle,
    disabled = props.disabled,
    iconOnly = props.iconOnly,
    title = props.title,
    splitButton = props.splitButton,
    customDropdown = props.customDropdown,
    toggleClassName = props.toggleClassName,
    dropdownClassName = props.dropdownClassName,
    className = props.className,
    open = props.open,
    dropup = props.dropup,
    pullRight = props.pullRight,
    noCaret = props.noCaret,
    onOpen = props.onOpen,
    onClose = props.onClose,
    onLabelButtonClick = props.onLabelButtonClick,
    usePortal = props.usePortal,
    popperConfig = props.popperConfig,
    remainingProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)(open),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    internalOpen = _useState2[0],
    setInternalOpen = _useState2[1];
  var _React$useState = _react["default"].useState(null),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    refDropdownToggle = _React$useState2[0],
    setRefDropdownToggle = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(null),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    refDropdownMenu = _React$useState4[0],
    setRefDropdownMenu = _React$useState4[1];
  var _React$useState5 = _react["default"].useState(null),
    _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
    refSplitButtonToggle = _React$useState6[0],
    setRefSplitButtonToggle = _React$useState6[1];
  var defaultPopperConfig = {
    placement: getPlacement(pullRight, dropup),
    modifiers: []
  };
  var popperParentRef = splitButton && pullRight ? refSplitButtonToggle : refDropdownToggle;
  var _usePopper = (0, _reactPopper.usePopper)(popperParentRef, refDropdownMenu, popperConfig || defaultPopperConfig),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  var wrapperRef = (0, _useClickOutside["default"])(function () {
    return closeMenu();
  });
  var dropdownRoot = (0, _portalRoot.getOrCreatePortalRoot)();
  var isUncontrolled = (0, _isNil["default"])(open);
  var shouldShowCaret = !noCaret && !splitButton && !iconOnly;
  (0, _react.useEffect)(function () {
    if (!isUncontrolled) {
      // console.log('update open from outside: ' + open);
      setInternalOpen(open);
    }
  }, [isUncontrolled, open]);
  var toggleOpen = function toggleOpen(event) {
    var isOpen = isUncontrolled ? internalOpen : open;
    if (isOpen) {
      closeMenu();
    } else {
      openMenu(event);
    }
  };
  var openMenu = function openMenu(event) {
    if (isUncontrolled) {
      setInternalOpen(true);
    }
    onOpen(event);
  };
  var closeMenu = function closeMenu() {
    if (isUncontrolled) {
      setInternalOpen(false);
    }
    onClose();
  };
  var handleSplitLabelButtonClick = function handleSplitLabelButtonClick() {
    closeMenu();
    onLabelButtonClick();
  };
  var handleDropdownButtonClick = splitButton ? handleSplitLabelButtonClick : toggleOpen;
  var isOpen = isUncontrolled ? internalOpen : open;
  var wrapperClasses = (0, _classnames["default"])('dropdown', 'btn-group', isOpen && 'open', className);
  var dropdownClasses = (0, _classnames["default"])(usePortal && 'dropdown-portal', splitButton && pullRight && 'pull-right', dropdownClassName);
  var dropdownMenu = /*#__PURE__*/_react["default"].createElement(_MenuItems["default"], (0, _extends2["default"])({
    className: dropdownClasses,
    ref: setRefDropdownMenu,
    style: styles.popper
  }, attributes.popper), customDropdown ? customDropdown : (0, _getMenuItems["default"])(items, toggleOpen));
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, remainingProps, {
    className: wrapperClasses,
    ref: wrapperRef
  }), /*#__PURE__*/_react["default"].createElement(_DropdownToggleButton["default"], {
    id: id,
    splitButton: splitButton,
    bsStyle: bsStyle,
    bsSize: bsSize,
    iconOnly: iconOnly,
    disabled: disabled,
    ref: setRefDropdownToggle,
    onClick: handleDropdownButtonClick,
    className: toggleClassName
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, title, shouldShowCaret && /*#__PURE__*/_react["default"].createElement(_Caret["default"], null))), splitButton && /*#__PURE__*/_react["default"].createElement(_SplitCaretButton["default"], {
    id: id,
    bsStyle: bsStyle,
    disabled: disabled,
    className: toggleClassName,
    onClick: toggleOpen,
    ref: setRefSplitButtonToggle
  }), isOpen && usePortal && /*#__PURE__*/_reactDom["default"].createPortal(dropdownMenu, dropdownRoot), isOpen && !usePortal && dropdownMenu);
};
ButtonDropdown.defaultProps = {
  id: Math.random().toString(36).substr(2, 16),
  items: [],
  iconOnly: false,
  noCaret: false,
  pullRight: false,
  splitButton: false,
  dropup: false,
  bsStyle: 'default',
  disabled: false,
  onOpen: _noop["default"],
  onClose: _noop["default"],
  onLabelButtonClick: _noop["default"],
  toggleClassName: '',
  usePortal: false,
  className: ''
};
ButtonDropdown.propTypes = {
  id: _propTypes["default"].string,
  title: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]).isRequired,
  open: _propTypes["default"].bool,
  dropup: _propTypes["default"].bool,
  pullRight: _propTypes["default"].bool,
  bsSize: _propTypes["default"].oneOf(['xs', 'sm', 'lg']),
  bsStyle: _propTypes["default"].oneOf(['default', 'primary', 'info', 'warning', 'danger', 'success', 'link', 'muted']),
  iconOnly: _propTypes["default"].bool,
  noCaret: _propTypes["default"].bool,
  splitButton: _propTypes["default"].bool,
  usePortal: _propTypes["default"].bool,
  items: _menuItemsPropTypes["default"].isRequired,
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  dropdownClassName: _propTypes["default"].string,
  toggleClassName: _propTypes["default"].string,
  onLabelButtonClick: _propTypes["default"].func,
  customDropdown: _propTypes["default"].node,
  popperConfig: _propTypes["default"].object,
  enableOnClickOutside: _propTypes["default"].func,
  disableOnClickOutside: _propTypes["default"].func,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func
};
var _default = ButtonDropdown;
exports["default"] = _default;